const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// ============================================
// GRAPH SECTION GSAP ANIMATION - SIMPLIFIED
// ============================================
function initGraphScrollAnimation() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("GSAP or ScrollTrigger not loaded yet");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // Define the data points for each stage
  const stages = [
    {
      points: [
        { x: 0, y: 20 },
        { x: 100, y: 30 },
        { x: 200, y: 25 },
        { x: 300, y: 40 },
        { x: 400, y: 15 },
        { x: 500, y: 20 }
      ],
      text: "When your glucose hits low..."
    },
    {
      points: [
        { x: -200, y: -200 },   
        { x: 50, y: -200 },       
        { x: 200, y: 100 },     
        { x: 400, y: 190 },     
        { x: 600, y: 190 },      
        { x: 800, y: 60 }
      ],
      text: "You need something fast..."
    },
    {
      points: [
        { x: -200, y: 20 },     
        { x: -10, y: 100 },       
        { x: 100, y: 140 },     
        { x: 250, y: 160 },    
        { x: 550, y: 180 },       
        { x: 800, y: 60 }
      ],
      text: "Something you can count on."
    },
    {
      points: [
        { x: -200, y: 20 },     
        { x: -150, y: 100 },       
        { x: 20, y: 140 },     
        { x: 100, y: 100 },    
        { x: 300, y: 70 },       
        { x: 500, y: 20 }
      ],
      text: "Pocket Gluca is here for all your lows because..."
    }
  ];

  const target = document.querySelector(".typewriter-js");
  if (!target) return;

  let currentStage = -1;
  let textTimeline = null;

  // Function to create path from points
  function createPath(points) {
    return points.map((point, index) => 
      (index === 0 ? 'M' : 'L') + ' ' + point.x + ' ' + point.y
    ).join(' ');
  }

  // Simplified text animation function
  function updateText(text, instant = false) {
    // Kill any existing text animation
    if (textTimeline) {
      textTimeline.kill();
      textTimeline = null;
    }
    
    if (instant) {
      target.textContent = text;
      return;
    }
    
    // Clear and animate new text
    target.textContent = "";
    const chars = text.split("");
    let charIndex = 0;
    
    textTimeline = gsap.timeline();
    textTimeline.to({}, {
      duration: chars.length * 0.03,
      onUpdate: function() {
        const progress = this.progress();
        const charsToShow = Math.floor(progress * chars.length);
        if (charsToShow > charIndex) {
          target.textContent = text.substring(0, charsToShow);
          charIndex = charsToShow;
        }
      },
      ease: "none"
    });
  }

  // Function to animate to a specific stage
  function animateToStage(stageIndex, duration = 1) {
    if (stageIndex >= stages.length || stageIndex < 0) return;
    if (currentStage === stageIndex) return;
    
    currentStage = stageIndex;
    const stage = stages[stageIndex];
    const targetPath = createPath(stage.points);
    const areaPath = targetPath + " L 500 200 L 0 200 Z";

    // Animate graph line and area
    gsap.to(".graph-line", {
      duration: duration,
      attr: { d: targetPath },
      ease: "power2.inOut"
    });

    gsap.to(".graph-area", {
      duration: duration,
      attr: { d: areaPath },
      ease: "power2.inOut"
    });

    // Animate data points
    stage.points.forEach((point, index) => {
      gsap.to(`.data-point-${index}`, {
        duration: duration,
        attr: { cx: point.x, cy: point.y },
        ease: "power2.inOut"
      });
    });

    // Update text
    updateText(stage.text);
  }

  // Set initial state
  const initialPath = createPath(stages[0].points);
  gsap.set(".graph-line", { attr: { d: initialPath } });
  gsap.set(".graph-area", { attr: { d: initialPath + " L 500 200 L 0 200 Z" } });
  stages[0].points.forEach((point, index) => {
    gsap.set(`.data-point-${index}`, { 
      attr: { cx: point.x, cy: point.y }
    });
  });
  updateText(stages[0].text, true);
  currentStage = 0;

  // Create a simple scroll-based animation
  ScrollTrigger.create({
    trigger: ".graph-section",
    start: "top top",
    end: "bottom bottom",
    pin: ".graph-container",
    scrub: 1,
    onUpdate: (self) => {
      const progress = self.progress;
      const stageIndex = Math.min(
        Math.floor(progress * stages.length), 
        stages.length - 1
      );
      
      if (stageIndex !== currentStage) {
        animateToStage(stageIndex);
      }
    }
  });


  ScrollTrigger.create({
    trigger: ".graph-section",
    start: "bottom bottom",
    end: "bottom top",
    onEnter: () => {
      gsap.to(".navbar", {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        onComplete: () => {
          gsap.to(".navbar-tooltip", {
            opacity: 1,
            y: 0,
            duration: 0.4,
            ease: "power2.out",
            delay: 0,
            onComplete: () => {
              startLogoShiver();
              gsap.to(".navbar-tooltip", {
                opacity: 0,
                y: 10,
                duration: 0.4,
                ease: "power2.in",
                delay: 2
              });
            }
          });
        }
      });
    },
    onLeaveBack: () => {
      gsap.set(".navbar-tooltip", { opacity: 0, y: 10 });
      stopLogoShiver();
    }
  });

  // LOGO SHIVER ANIMATION
  let shiverAnimations = [];

  function startLogoShiver() {
    stopLogoShiver();
    
    gsap.utils.toArray("#logo .letter").forEach((letter, index) => {
      const animation = gsap.timeline({ repeat: 0 })
        .to(letter, {
          scaleX: 0.65,
          skewX: 2,
          duration: 0.15,
          ease: "sine.inOut"
        })
        .to(letter, {
          scaleX: 1.45,
          skewX: -2,
          duration: 0.1,
          ease: "sine.inOut"
        })
        .to(letter, {
          scaleX: 1,
          skewX: 0,
          duration: 0.15,
          ease: "sine.inOut"
        });
      
      animation.delay(index * 0.1);
      shiverAnimations.push(animation);
    });
  }

  function stopLogoShiver() {
    shiverAnimations.forEach(animation => animation.kill());
    shiverAnimations = [];
    
    gsap.utils.toArray("#logo .letter").forEach(letter => {
      gsap.set(letter, {
        scaleY: 1,
        scaleX: 1,
        skewX: 0,
        clearProps: "transform"
      });
    });
  }

  // Refresh ScrollTrigger after setup
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
}


// HOVER TRIGGER FOR LOGO SHIVER
let activeShiver = null;

// Factory creates a new full shiver timeline with identical look
function createShiver({ loop = false }) {
  const tl = gsap.timeline({ repeat: loop ? -1 : 0, yoyo: false });

  gsap.utils.toArray("#logo .letter").forEach((letter, index) => {
    tl.to(letter, {
      scaleX: 0.65,
      skewX: 2,
      duration: 0.15,
      ease: "sine.inOut"
    }, index * 0.1)
    .to(letter, {
      scaleX: 1.45,
      skewX: -2,
      duration: 0.1,
      ease: "sine.inOut"
    }, index * 0.1 + 0.15)
    .to(letter, {
      scaleX: 1,
      skewX: 0,
      duration: 0.15,
      ease: "sine.inOut"
    }, index * 0.1 + 0.25);
  });

  return tl;
}

function startShiver({ loop = false } = {}) {
  stopShiver();
  activeShiver = createShiver({ loop });
}

function stopShiver() {
  if (activeShiver) activeShiver.kill();
  activeShiver = null;
  gsap.set("#logo .letter", { clearProps: "transform" });
}

// Tooltip control
function showTooltip() {
  gsap.to(".navbar-tooltip", {
    opacity: 1,
    y: 0,
    duration: 0.4,
    ease: "power2.out"
  });

  gsap.to(".navbar-tooltip", {
    opacity: 0,
    y: 10,
    duration: 0.4,
    ease: "power2.in",
    delay: 2
  });
}


const logo = document.querySelector(".logo");

if (logo) {
  logo.addEventListener("mouseenter", () => {
    startShiver();
    showTooltip();
  });

  logo.addEventListener("mouseleave", () => {
    stopShiver();
  });
}


// ============================================
// BASIC SCROLL IN ANIMATIONS (non-GSAP)
// ============================================
const triggeredElements = new Set();

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    const elementTarget = element.target;
    const elementId = elementTarget.dataset.scrollId || generateUniqueId(elementTarget);
    
    if (triggeredElements.has(elementId)) {
      return;
    }
    
    if (element.isIntersecting) {
      elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      
      if (elementTarget.hasAttribute('data-cascade')) {
        elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      
      triggeredElements.add(elementId);
      observer.unobserve(elementTarget);
    }
  });
}

function generateUniqueId(element) {
  if (!element.dataset.scrollId) {
    element.dataset.scrollId = 'scroll-' + Math.random().toString(36).substr(2, 9);
  }
  return element.dataset.scrollId;
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  
  // Filter out graph section elements - GSAP handles those
  const filteredElements = animationTriggerElements.filter(element => {
    return !element.closest('.graph-section') && 
           !element.classList.contains('graph-section');
  });
  
  if (filteredElements.length === 0) return;

  if (isDesignModeEvent) {
    filteredElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  });
  
  filteredElements.forEach((element) => {
    generateUniqueId(element);
    observer.observe(element);
  });
}

// ============================================
// ZOOM IN ANIMATION
// ============================================
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;
        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function throttle(func, delay = 16) {
  let lastCall = 0;
  return function(...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return func(...args);
  };
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

// ============================================
// INITIALIZATION
// ============================================
window.addEventListener('DOMContentLoaded', () => {
  // Initialize graph animation if GSAP is loaded
  if (document.querySelector('.graph-section')) {
    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      initGraphScrollAnimation();
    } else {
      // Wait for GSAP to load
      const checkGSAP = setInterval(() => {
        if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
          clearInterval(checkGSAP);
          initGraphScrollAnimation();
        }
      }, 100);
    }
  }
  
  // Initialize basic scroll animations
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();

  // Trigger initial shiver and tooltip on page load
  setTimeout(() => {
    startShiver();
    showTooltip();
  }, 500); // Small delay to ensure everything is loaded
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}